import { ReactElement } from 'react';
import { Dropdown } from 'components/elements/inputs/dropdown/Dropdown';
import { DropdownItem } from 'components/elements/inputs/dropdown/Dropdown.types';
import { usePolyglotT } from 'utils/locale/locale';
import {
  SupportedLocalesValues,
  LanguageLabelsValues,
} from 'utils/locale/locale.types';
import {
  SupportedLocales,
  LanguageLabels,
} from 'utils/locale/locale.constants';
import { useRouter } from 'next/router';

interface LocalePickerProps {
  showLabel?: boolean;
}

const LocalePicker = ({
  showLabel = true,
}: LocalePickerProps): ReactElement => {
  const router = useRouter();
  const { setLocale, locale, t, setShouldPersistLoginPageLanguage } =
    usePolyglotT();

  const dropdownItems: Array<
    DropdownItem<LanguageLabelsValues, SupportedLocalesValues>
  > = Object.values(SupportedLocales).map(
    (
      locale: SupportedLocalesValues
    ): DropdownItem<LanguageLabelsValues, SupportedLocalesValues> => ({
      label: LanguageLabels[locale],
      value: locale,
    })
  );

  const onLocaleChange = async (
    locale:
      | DropdownItem<LanguageLabelsValues, SupportedLocalesValues>
      | null
      | undefined
  ) => {
    if (locale) {
      await setLocale(locale.value, router);

      setShouldPersistLoginPageLanguage(true);
    }
  };

  return (
    <Dropdown<LanguageLabelsValues, SupportedLocalesValues>
      id='locale-picker'
      label={showLabel ? t('general.select_language') : undefined}
      items={dropdownItems}
      selected={dropdownItems.find((l) => l.value === locale)}
      onChange={onLocaleChange}
    />
  );
};

export default LocalePicker;
